import { Routes, Route } from "react-router-dom";
import {Index} from './Pages/Index.jsx';
import { Contributionaltasklist } from './Pages/Contributionaltasklist.jsx';
import { Detail } from './Pages/Detail.jsx';
import { Faq } from './Pages/Faq.jsx';
import { Authenticate } from './Pages/Authenticate.jsx';
import { NoPage } from './Pages/NoPage.jsx';
//import { Certificate } from './Pages/Certificate.jsx';
import { Footer } from './components/Footer.jsx';
import { ReusableRepo } from "./Pages/ReusableRepo.jsx";
import {RepoDetail} from "./Pages/RepoDetail.jsx";
import UserProfileView from "./sections/home/UserProfileView.jsx";
import UserProfileEdit from "./sections/home/UserProfileEdit.jsx";
import PublicProject from "./sections/publicprojects/PublicProject.jsx";

function App() {
  return (
    <> 
    <Routes>
          <Route path="/reusablerepo/" element={<ReusableRepo />}/>
          <Route path="/reusablerepo/detail/:id" element={<RepoDetail />}/>
          <Route path="/users/:name" element={<UserProfileView />}/>
          <Route path="/users/edit" element={<UserProfileEdit />}/>
          <Route path="/collabwithgov/" element={<Index />}/>
          <Route path="/collabwithgov/contributionaltasklist" element={<Contributionaltasklist />}/>
          <Route path="/collabwithgov/faq" element={<Faq />} />
          {/* <Route path="/collabwithgov/certificate/:uri" element={<Certificate />} /> */}
          <Route path="/collabwithgov/detail/:id" element={<Detail />} />
          <Route path="/collabwithgov/authenticate" element={<Authenticate />} />
          <Route path="/collabwithgov/*" element={<NoPage />} />
          <Route path="/reusablerepo/*" element={<NoPage />} />
          <Route path="/users/*" element={<NoPage />} />
          <Route path="/collabwithgov/publicprojects/" element={<PublicProject />}/>
          <Route path="/projects/" element={<PublicProject />}/>
          <Route path="/projects/*" element={<NoPage />} />

      </Routes>
      <Footer/>
    </>
  );
}

export default App;
